<template>
    <div class="mt-5 mb-8 px-4 flex items-center">
        <UIAvatar :avatar="config.data.avatar" />
        <UIHtml
            :html="config.data.avatar.description"
            class="prose prose-sm max-w-full ml-2"
            style="overflow-wrap: anywhere;"
        />
    </div>
</template>

<script setup>
    import UIAvatar from '@/components/ui/UIAvatar.vue'
    import UIHtml from '@/components/ui/UIHtml.vue'

    const props = defineProps({
        config: Object,
    })
</script>
